import { Dropdown, Menu, MenuButton, MenuItem } from '@mui/joy';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import DownloadButtonIcon from '../../../assets/svg/downloadIconGray.svg';
import { generateReportDocx } from '../../../assets/utils/docx/FinalReportDocx';
import { generateFinalReportPDF } from '../../../assets/utils/pdfs/FinalReportPDF';
import { ModifiedFinalReportDocument } from '../../../interfaces/ModifiedFinalReportDocument';
import reportService from '../../../services/reportService';
import { RootState } from '../../../utils/store';

interface DownloadReportButtonProps {
  pdfData: ModifiedFinalReportDocument;
}

const DownloadFinalReportButton = ({ pdfData }: DownloadReportButtonProps) => {
  const roles = useSelector((state: RootState) => state.userRoles);
  const generateFinalReport = async () => {
    const reportPDF = await generateFinalReportPDF(pdfData);
    const fileURL = URL.createObjectURL(reportPDF);
    window.open(fileURL, '_blank');
    if (pdfData.referenceID) {
      reportService.createDownloadAuditLog(
        pdfData.caseManagerReferenceId,
        `${pdfData.title}.pdf`,
      );
    }
  };
  const handleGenerateDocx = () => {
    generateReportDocx(pdfData);
    if (pdfData.referenceID) {
      reportService.createDownloadAuditLog(
        pdfData.caseManagerReferenceId,
        `${pdfData.title}.docx`,
      );
    }
  };
  return (
    <Dropdown>
      <MenuButton
        disabled={!roles.is_allowed_to_download_final_report}
        variant='soft'
        color='neutral'
        startDecorator={<img src={DownloadButtonIcon} alt='' />}
      >
        <FormattedMessage defaultMessage='Final Report' />
      </MenuButton>
      <Menu disablePortal>
        <MenuItem onClick={handleGenerateDocx}>
          <FormattedMessage defaultMessage='Word' />
        </MenuItem>
        <MenuItem onClick={generateFinalReport}>
          <FormattedMessage defaultMessage='PDF' />
        </MenuItem>
      </Menu>
    </Dropdown>
  );
};

export default DownloadFinalReportButton;
